class GdprAccordion {
    constructor() {
        this.accordionElements = document.querySelectorAll('.jsGdprAccordionElement');
        if (this.accordionElements) {
            this.events();
        }
    }

    events() {
        this.accordionElements.forEach(element => {
            if(!element.classList.contains('el-added')) {
                element.addEventListener('click', ()=> {
                    var closestSibling = element.nextElementSibling;
                    console.log(closestSibling);
                    const content = closestSibling.querySelector('.jsGdprAccordionContent');
                    this.handleAccordionClick(element, content)
                })
                element.classList.add('el-added');
            }
        });
    }

    handleAccordionClick(element, content) {
        element.classList.toggle('active');
        content.classList.toggle('expand');
    }

    refreshAccordion() {
        this.accordionElements = document.querySelectorAll('.jsGdprAccordionElement');
        this.events();
    }
}

export default GdprAccordion;
